import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class ListSearchStateService {
  private originalSearchObject: SearchConfig = {
    query: undefined,
    sortBy: '',
    reverse: false,
    includeSubcompanies: false,
    folderId: null,
    folderKind: undefined,
    count: 40
  };
  private searchObject: SearchConfig = {...this.originalSearchObject};

  private search$ = new Subject<SearchConfig>();

  init(search: SearchConfig) {
    this.searchObject = {...search};
    this.originalSearchObject = {...search};
  }

  doSearch() {
    this.search$.next({
      ...this.searchObject,
    });
  }

  searchChanged() {
    return this.search$.asObservable();
  }

  reset() {
    this.searchObject = {...this.originalSearchObject};
    this.doSearch();
  }

  setQuery(query: string) {
    this.searchObject.query = query;
  }

  sortBy(sortBy: string, reverse = undefined) {
    if (this.searchObject.sortBy === sortBy) {
      this.searchObject.reverse = !this.searchObject.reverse;
    } else {
      this.searchObject.sortBy = sortBy;
      this.searchObject.reverse = !!reverse;
    }
    this.doSearch();
  }

  setReverse(reverse: boolean) {
    this.searchObject.reverse = reverse;
  }

  setIncludeSubcompanies(includeSubcompanies: boolean) {
    this.searchObject.includeSubcompanies = includeSubcompanies;
  }

  setFolderId(folderId: string) {
    this.searchObject.folderId = folderId;
  }

  setKind(kind: 'Display' | 'Schedule' | 'Presentation') {
    this.searchObject.folderKind = kind;
  }

  getSearchObject() {
    return this.searchObject;
  }
  
}

export interface SearchConfig {
  query: string | undefined;
  sortBy: string;
  reverse: boolean;
  includeSubcompanies: boolean;
  folderId: string | null;
  folderKind: 'Display' | 'Schedule' | 'Presentation' | undefined;
  count: number;
}
